import { RANK_STATUS } from './contants';

const initState = {
	rankStatus: [],
	// Master = hạng cao nhất, suy ra từ rank của login-streak. Để ở store cho
	// mọi nơi (Home, DailyReward...) dùng chung thay vì tự tính lại.
	// isMaster: false,
}

const reducerRankStatus = (state = initState, actions) => {
	switch (actions.type) {
		case RANK_STATUS:
			return {
				...state,
				rankStatus: actions.payload.data,
				isMaster: actions.payload.data?.rank?.toUpperCase() === 'MASTER',
			}
		default:
			return state
	}
}
export default reducerRankStatus
